import StudentChatComp from "./Chat/StudentChatComp";
const StuSelectedBatchList = () => {
  const userToken = sessionStorage.getItem("token");

  return <div>{userToken ? <StudentChatComp /> : "loading..."}</div>;
};

export default StuSelectedBatchList;
